import { render, staticRenderFns } from "./AcceptInvite.vue?vue&type=template&id=2d8a2f7e&scoped=true"
import script from "./AcceptInvite.vue?vue&type=script&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&lang=js"
import style0 from "./Login.scss?vue&type=style&index=0&id=2d8a2f7e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a2f7e",
  null
  
)

export default component.exports